import { SizableText, SmartLink, styled, XStack } from '@my/ui'
import { colors } from '@my/ui/src/colors'
import { XStackProps } from '@my/ui'
import React from 'react'

export type NavCarouselItem = {
  label: string
  href: string
  Icon?: React.NamedExoticComponent<any>
}

const NavButton = styled(XStack, {
  position: 'relative',
  ai: 'center',
  mr: '$2',
  borderRadius: '$3',
  py: '$2',
  px: '$3',
  width: 'auto',
  bg: '$white',
  gap: '$2',
  borderWidth: 1,
  borderColor: '$grey3',
  hoverStyle: {
    opacity: 0.9,
    bg: '$primary4',
  },
  focusStyle: {
    opacity: 0.9,
    bg: '$primary4',
  },
  pressStyle: {
    opacity: 0.6,
    bg: '$primary4',
  },
  variants: {
    active: {
      true: {
        opacity: 1,
        bg: '$primary',
        hoverStyle: {
          bg: '$primary4',
        },
        pressStyle: {
          bg: '$primary5',
        },
        focusStyle: {
          bg: '$primary4',
        },
      },
    },
  } as const,
})
interface NavCarouselItemProps extends NavCarouselItem {
  active: boolean
}

export const NavCarouselItem = ({
  active,
  href,
  label,
  Icon,
  ...props
}: NavCarouselItemProps & XStackProps) => {
  return (
    <XStack {...props}>
      <SmartLink Component={NavButton} href={href} active={active}>
        {Icon && <Icon size={24} color={active ? colors.black : colors.grey8} />}
        <SizableText size="$3" fow="600" color={active ? '$black' : '$grey8'}>
          {label}
        </SizableText>
      </SmartLink>
    </XStack>
  )
}
